import { motion } from "framer-motion";

export function Header({ title, subtitle, action, icon: Icon }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="flex items-start justify-between mb-8"
    >
      <div>
        <div className="flex items-center gap-3 mb-2">
          {Icon && (
            <div className="bg-gradient-to-br from-blue-100 to-purple-100 p-3 rounded-xl">
              <Icon className="text-blue-600" size={24} />
            </div>
          )}
          <div>
            <h1 className="text-4xl font-bold text-gray-900">{title}</h1>
            {subtitle && (
              <p className="text-gray-500 mt-1">{subtitle}</p>
            )}
          </div>
        </div>
      </div>
      {action && <div>{action}</div>}
    </motion.div>
  );
}

export function Container({ children, className = "" }) {
  return (
    <div className={`max-w-7xl mx-auto px-6 py-8 ${className}`}>
      {children}
    </div>
  );
}

export function PageGrid({ children, cols = 3 }) {
  return (
    <div className={`grid grid-cols-1 md:grid-cols-2 lg:grid-cols-${cols} gap-6 mb-8`}>
      {children}
    </div>
  );
}
